import React from "react";
import { useNavigate } from "react-router-dom";

interface NavItemProps {
  title: string;
  component: React.ReactNode;
  className?: string;
  link: string;
  toggle?: () => void;
  disabled?: boolean;
}

const NavItem = (props: NavItemProps) => {
  const { title, component, className, toggle, link, disabled = false } = props;

  const navigate = useNavigate();
  function handleNavigation() {
    if (!disabled) navigate(link);
    if (toggle) toggle();
  }
  return (
    <div
      onClick={handleNavigation}
      className={`px-4 py-2  ml-3 ${
        disabled
          ? "cursor-not-allowed text-gray-600"
          : "cursor-pointer text-gray-400 hover:text-white"
      }  select-none ${className}`}
    >
      {component}
      <span>{title}</span>
    </div>
  );
};

export default NavItem;
